/* 学员的学习目标页面 */
<template>
<div>
  <div><span class='flex-row flex-center target-header' style="color: orange">学员目标</span></div>
  <div class="flex-row flex-center">
    <div class="target-page flex-column">
      <div class="flex-row target target-listen" v-if="stu_target.listening_desc">
          <div class="target-img"><img src="/static/images/listen.svg"></div>
          <div>
              <div class="title" id="listening_desc">{{stu_target.listening_desc}}</div>
              <div class="resource-list" id="audio_content">
                <li v-for="audio in stu_target.audio_content">
                  <a :href="'/resource/audio/' + audio.id">{{audio.title_cn}}({{audio.title}})</a>
                </li>
              </div>
          </div>
      </div>

      <div class="flex-row target target-speak" v-if="stu_target.correspondence_desc">
          <div class="target-img"><img src="/static/images/television.svg"></div>
          <div>
              <div class="title" id="correspondence_desc">{{stu_target.correspondence_desc}}</div>
              <div class="resource-list" id="video_content">
                <li v-for="video in stu_target.video_content">
                  <a :href="'/resource/video/' + video.id">{{video.title_cn}}({{video.title}})</a>
                </li>
              </div>
          </div>
      </div>

      <div class="flex-row target target-read" v-if="stu_target.reading_desc">
          <div class="target-img"><img src="/static/images/read.svg"></div>
          <div>
              <div class="title" id="reading_desc">{{stu_target.reading_desc}}</div>
              <div class="resource-list" id="book_content">
                <li v-for="book in stu_target.book_content">
                  <a :href="'/resource/book/' + book.id">{{book.title_cn}}({{book.title}})</a>
                </li>
              </div>
          </div>
      </div>

      <div class="flex-row target target-write" v-if="stu_target.writing_desc">
          <div class="target-img"><img src="/static/images/write.svg"></div>
          <div><div class="title" id="writing_desc">无</div></div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
require('@/assets/css/common-flex.css')
require('@/assets/css/target.css')

export default {
  name: 'StudentTarget',
  props: ['stu_target'],
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/template/target/StudentTarget.vue